import load from 'sdk/payerUserAudit';
import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/payerUserAudit';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
